import { setImgPlaceholder } from "../utils/img-placeholder";
import { loadClientWidgets } from "../utils/loadClientWidgets";
import startingGrid from "../utils/starting-grid";
import { widgets } from "../widgets";

import "@sky-it-livedata/livedata-sports-design-system/lib/styles/stylesheet.min.css";

export const initClient = () => loadClientWidgets(widgets);

initClient();

document.addEventListener('DOMContentLoaded', () => {
  setImgPlaceholder();
  startingGrid();
});
